








































import VueOptions from '@utils/VueOptions'
import RecapUtility from '@utils/RecapUtility'

settings =
  name: 'RemittanceResourceListItem'

  vue:
    props: ['item', 'actions', 'selected', 'backgroundColor']

    computed:
      sponsor: ->
        @ctxSponsorOrg @item

      supplier: ->
        @ctxSupplierOrg @item

      listing: ->
        @item.ctx.listing

      offer: ->
        @ctxOffer @item

      brandInfo: ->
        @offer.brand_info

      dueDate: ->
        dayjs(@item.end_date.slice(0, 10)).add(@item.grace_period, 'days')

      totalPhotos: ->
        @item.photos.length - @item.photos_invalid.length

      totalAnswers: ->
        answers = RecapUtility.requiredAnswers @item
        Object.keys(answers).length

      totalRequiredQuestions: ->
        questions = RecapUtility.requiredQuestions @item
        Object.keys(questions).length

    methods:
      shouldExpandCollumn: (size) ->
        return true if @rowSize >= 2 && size == 'MEDIUM'
        return true if @rowSize == 3 && size == 'LARGE'

export default VueOptions.vue settings
